import { call, fork, take } from 'redux-saga/effects/';

export const takeOnce = (pattern, saga, ...args) =>
  fork(function* () {
    // eslint-disable-line
    const action = yield take(pattern);
    yield call(saga, ...args.concat(action));
  });
